import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import { getFullDateString } from '../../../Util/dateTime';
import Waves from 'node-waves'

class Feeds extends Component {
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  onClick = (goTo, id, workplaceId) => {
    if (goTo)
      this.props.goToDailyReport(new Date(goTo), id, workplaceId);
  };
  onScroll = () => {
  };
  render() {
    const { feeds, workplaces } = this.props;
    let feedRows = feeds.map((feed) => {
      let isFeedDelete = feed.text.indexOf("slettede") !== -1
      let gotoApv = feed.data.apv === 'APV'
      let versionString = feed.data ? (feed.data.version ? " #" + feed.data.version + " for " : " ") : " "
      return (
        <div
          key={feed.id}
          className={(feed.goto == null || isFeedDelete) && gotoApv === false ? null : "waves-btn"}
          style={styles.row}
          onClick={() => {
            if (gotoApv)
              this.props.gotoAPV(feed.workplaceId)
            else if (!isFeedDelete)
              this.onClick(feed.goto, feed.data ? feed.data.id : null, feed.workplaceId)
          }}>
          <div style={styles.textContainer}>
            {feed.user ? <span style={styles.user}>{feed.user} </span> : null}
            {feed.text.replace('oprettede nyt tilbud', 'oprettede nyt estimat')}
            {versionString}
            {feed.goto == null ? null : getFullDateString(new Date(feed.goto), true)}
            {feed.data.emails ?
              <span> Til:
              {feed.data.emails.map((email, i) => {
                  return (
                    <span key={i}> {email}{i === feed.data.emails.length - 1 ? null : ","}</span>
                  )
                })}
              </span>
              :
              null
            }
          </div>
          <div style={styles.timeContainer}>
            {feed.goto == null || isFeedDelete ? null : <i style={styles.icon} className="fa fa-external-link" aria-hidden="true"></i>}
            {gotoApv == true ? <i style={styles.icon} className="fa fa-external-link" aria-hidden="true"></i> : null}
            <div style={styles.time}>{feed.timestamp}</div>
          </div>
          <div style={{
            paddingTop: '8px',
            fontSize: '12px',
            fontStyle: 'italic',
            maxWidth: '280px',
            cursor: 'alias',
          }}
            onClick={(e) => {
              e.stopPropagation();
              this.props.gotoWorkplace(feed.workplaceId)
            }}>
            Arbejdsted: {workplaces[feed.workplaceId] ? workplaces[feed.workplaceId].name : null}
          </div>
        </div>
      )
    });
    return (
      <div
        ref={(divElement) => this.divElement = divElement}
        onScroll={(e) => {
          if (this.divElement.scrollHeight - this.divElement.scrollTop < this.divElement.clientHeight + (feeds.length * 6)) {
            this.props.moreFeeds(feeds.length)
          }
        }}
        style={styles.listsContainer}>
        {feedRows}
      </div>
    )
  }
}

var styles = {
  listsContainer: {
    backgroundColor: '#fff',
    borderRadius: '2px',
    overflowY: 'scroll',
    marginRight: '-15px',
    height: '95%',
    scrollBehavior: 'smooth',
    WebkitOverflowScrolling: 'touch'
  },
  row: {
    position: 'relative',
    width: '96%',
    marginLeft: '2%',
    height: 'auto !important',
    minHeight: '40px',
    overflow: 'hidden',
    textAlign: 'left',
    lineHeight: 'normal',
    whiteSpace: 'normal',
    padding: '10px 0',
    borderRadius: '0px',
    borderBottom: '1px solid',
    borderColor: semanticColors.mainBackground
  },
  textContainer: {
    width: '70%',
    display: 'inline-block'
  },
  timeContainer: {
    width: '28%',
    display: 'inline-block',
    height: '30px',
    padding: '5px',
    position: 'absolute',
    top: ' 30%',
    right: '0',
    transform: 'translateY(-50%)'
  },
  icon: {
    color: greyScaleColors.greyLight
  },
  time: {
    display: 'inline-block',
    float: 'right',
    color: greyScaleColors.greyLight
  },
  user: {
    fontWeight: '600'
  }
}

export default Radium(Feeds);


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/DepartmentFeed/feed.js